// @flow
import React, { type Element } from 'react';
import NewsfeedEdit from './NewsfeedEdit';

const NewsfeedList = (): Element<*> => <NewsfeedEdit />;

export default NewsfeedList;
